import { combineReducers } from 'redux';
import { chunkDetailsMOReducer } from './chunkDetailsMOReducer';
import { chunkListMOReducer } from './chunkListMOReducer';
import { wordTypeScoreMOReducer } from './wordTypeScoreMOReducer';
import { isShowInfoPaneReducer } from './isShowInfoPaneReducer';
import { isShowSettingsPaneReducer } from './isShowSettingsPaneReducer';
import { exclusionsMOReducer } from './exclusionsMOReducer';
import { themeMOReducer } from './themeMOReducer';
import { graphCheckListMOReducer } from './graphCheckListMOReducer';
export const taskPaneReducers = {
	// MO
	chunkDetailsMO: chunkDetailsMOReducer,
	chunkListMO: chunkListMOReducer,
	wordTypeScoreMO: wordTypeScoreMOReducer,
	exclusionsMO: exclusionsMOReducer,
	themeMO: themeMOReducer,
	graphCheckListMO: graphCheckListMOReducer,

	// TRUE - FALSE
	isShowInfoPane: isShowInfoPaneReducer,
	isShowSettingsPane: isShowSettingsPaneReducer,
};
export const rootReducer = combineReducers(taskPaneReducers);
